import RootLayout from "./components/layout/rootLayout";
import { ToastProvider } from "./components/ui/ToastContext";
import TourGuide from "./components/ui/tourGuide/TourGuide";
import ProtectedRoute from "./routes/ProtectedRoute";

const App = () => {
  return (
    <>
      {/* <ProtectedRoute> */}
      <RootLayout />
      {/* <div id="app-container">
        <TourGuide />
      </div> */}
      {/* </ProtectedRoute> */}
    </>
  );
};

export default App;
